import React from 'react';
import { X, AlertTriangle } from 'lucide-react';

/**
 * DeleteConfirmationModal Component
 * Confirmation dialog for deleting a property
 */
const DeleteConfirmationModal = ({ isOpen, onClose, onConfirm, propertyName, isDeleting }) => {
    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 z-50 overflow-y-auto">
            {/* Backdrop */}
            <div
                className="fixed inset-0 bg-black bg-opacity-50 transition-opacity"
                onClick={onClose}
            />

            {/* Modal */}
            <div className="flex min-h-full items-center justify-center p-4">
                <div className="relative bg-white rounded-lg shadow-xl max-w-md w-full p-6">
                    {/* Close Button */}
                    <button
                        onClick={onClose}
                        className="absolute top-4 right-4 text-soil-400 hover:text-soil-600"
                    >
                        <X className="h-5 w-5" />
                    </button>

                    {/* Icon */}
                    <div className="flex items-center justify-center w-12 h-12 mx-auto bg-murram-100 rounded-full mb-4">
                        <AlertTriangle className="h-6 w-6 text-murram-600" />
                    </div>

                    {/* Content */}
                    <div className="text-center mb-6">
                        <h3 className="text-lg font-semibold text-soil-900 mb-2">
                            Delete Property
                        </h3>
                        <p className="text-sm text-soil-600">
                            Are you sure you want to delete{' '}
                            <span className="font-medium text-soil-900">{propertyName}</span>?
                        </p>
                        <p className="text-sm text-soil-600 mt-2">
                            This action will mark the property as inactive and hide it from public view.
                            You can restore it later if needed.
                        </p>
                    </div>

                    {/* Actions */}
                    <div className="flex items-center space-x-3">
                        <button
                            onClick={onClose}
                            disabled={isDeleting}
                            className="flex-1 px-4 py-2 bg-soil-100 text-soil-600 rounded-lg font-medium hover:bg-soil-100/70 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
                        >
                            Cancel
                        </button>
                        <button
                            onClick={onConfirm}
                            disabled={isDeleting}
                            className="flex-1 px-4 py-2 bg-murram-600 text-white rounded-lg font-medium hover:opacity-90 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
                        >
                            {isDeleting ? 'Deleting...' : 'Delete Property'}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default DeleteConfirmationModal;
